/* eslint-disable import/prefer-default-export */
export const APP_NAME = 'Zipteam';
export const CONTACTS = Object.freeze({
  SUPPORT: 'support@zipteam.com',
});
